import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Contacts from "@/pages/Contacts";
import Opportunities from "@/pages/Opportunities";
import Tasks from "@/pages/Tasks";
import Academy from "@/pages/Academy";
import StudyAbroad from "@/pages/StudyAbroad";
import Wealth from "@/pages/Wealth";
import Insurance from "@/pages/Insurance";
import Digital from "@/pages/Digital";
import HR from "@/pages/HR";
import Franchise from "@/pages/Franchise";
import Partners from "@/pages/Partners";
import Reports from "@/pages/Reports";
import Automations from "@/pages/Automations";
import Quotations from "@/pages/Quotations";
import Invoices from "@/pages/Invoices";
import Commissions from "@/pages/Commissions";
import StudentPortal from "@/pages/StudentPortal";
import FranchisePortal from "@/pages/FranchisePortal";
import PublicLeadForm from "@/pages/PublicLeadForm";
import PublicCatalogue from "@/pages/PublicCatalogue";
import PublicCatalogueDetail from "@/pages/PublicCatalogueDetail";
import AdminUsers from "@/pages/AdminUsers";
import AccessRequestsPage from "@/pages/AccessRequests";
import RequestAccess from "@/pages/RequestAccess";
import PartnerRegister from "@/pages/PartnerRegister";
import PartnerPaymentSubmit from "@/pages/PartnerPaymentSubmit";
import AdminPartnerPayments from "@/pages/AdminPartnerPayments";
import AdminPartnerEarnings from "@/pages/AdminPartnerEarnings";
import MyPartnerEarnings from "@/pages/MyPartnerEarnings";
import AdminPaymentSettings from "@/pages/AdminPaymentSettings";
import AdminApprovals from "@/pages/AdminApprovals";
import MyDigitalId from "@/pages/MyDigitalId";
import VerifyDigitalId from "@/pages/VerifyDigitalId";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangePassword from "@/pages/ChangePassword";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/leadform" element={<PublicLeadForm />} />
          <Route path="/lead" element={<PublicLeadForm />} />
          <Route path="/catalogue" element={<PublicCatalogue />} />
          <Route path="/catalogue/:programId" element={<PublicCatalogueDetail />} />
          <Route path="/verify/:code" element={<VerifyDigitalId />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/request-access" element={<RequestAccess />} />
          <Route path="/partner/register" element={<PartnerRegister />} />
          <Route path="/partner/payment/:appId" element={<PartnerPaymentSubmit />} />
          <Route path="/admin/partner-payments" element={<ProtectedRoute><AdminPartnerPayments /></ProtectedRoute>} />
          <Route path="/admin/partner-earnings" element={<ProtectedRoute><AdminPartnerEarnings /></ProtectedRoute>} />
          <Route path="/my-earnings" element={<ProtectedRoute><MyPartnerEarnings /></ProtectedRoute>} />
          <Route path="/admin/payment-settings" element={<ProtectedRoute><AdminPaymentSettings /></ProtectedRoute>} />
          <Route path="/signup" element={<RequestAccess />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
          <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
          <Route path="/opportunities" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
          <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
          <Route path="/divisions/academy" element={<ProtectedRoute><Academy /></ProtectedRoute>} />
          <Route path="/divisions/study-abroad" element={<ProtectedRoute><StudyAbroad /></ProtectedRoute>} />
          <Route path="/divisions/mbbs" element={<ProtectedRoute><StudyAbroad mbbsOnly={true} /></ProtectedRoute>} />
          <Route path="/divisions/wealth" element={<ProtectedRoute><Wealth /></ProtectedRoute>} />
          <Route path="/divisions/insurance" element={<ProtectedRoute><Insurance /></ProtectedRoute>} />
          <Route path="/divisions/digital" element={<ProtectedRoute><Digital /></ProtectedRoute>} />
          <Route path="/hr" element={<ProtectedRoute><HR /></ProtectedRoute>} />
          <Route path="/franchise" element={<ProtectedRoute><Franchise /></ProtectedRoute>} />
          <Route path="/partners" element={<ProtectedRoute><Partners /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/automations" element={<ProtectedRoute><Automations /></ProtectedRoute>} />
          <Route path="/finance/quotations" element={<ProtectedRoute><Quotations /></ProtectedRoute>} />
          <Route path="/finance/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          <Route path="/finance/commissions" element={<ProtectedRoute><Commissions /></ProtectedRoute>} />
          <Route path="/portal/student" element={<ProtectedRoute><StudentPortal /></ProtectedRoute>} />
          <Route path="/portal/franchise" element={<ProtectedRoute><FranchisePortal /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/access-requests" element={<ProtectedRoute><AccessRequestsPage /></ProtectedRoute>} />
          <Route path="/admin/approvals" element={<ProtectedRoute><AdminApprovals /></ProtectedRoute>} />
          <Route path="/my-id" element={<ProtectedRoute><MyDigitalId /></ProtectedRoute>} />
          <Route path="/account/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
